import { ModalKey, useOpenModal } from '@finn/ua-modals';
import { CTA, Image } from '@finn/ui-components';
import { parseToHtml } from '@finn/ui-utils';
import { useCallback, useRef } from 'react';

import { PromoCosmicMetadata } from '~/types/UIModules';

import CosmicModule from '../CosmicModule';
import { Voucher } from './Voucher';

type Props = {
  data: PromoCosmicMetadata;
  slug?: string;
};

const PromoContent = ({ data, slug = '' }: Props) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const isJobAuto = slug === 'promo-b2b-job-auto-3-version-2';
  const openModal = useOpenModal();

  const handleClick = useCallback(() => {
    if (isJobAuto) {
      openModal(ModalKey.JOBAUTO_WHITEPAPER_MODAL);
    }
  }, [isJobAuto, openModal]);

  return (
    <div ref={containerRef}>
      {data.override_heading ? (
        <>
          <h1 className="mb-4 inline-block body-16-semibold">
            {parseToHtml(data.override_heading)}
          </h1>
          <h2 className="mobile-t3-semibold md:web-t3-semibold">
            {parseToHtml(data.title)}
          </h2>
        </>
      ) : (
        <h2 className="mobile-t3-semibold md:web-t3-semibold">
          {parseToHtml(data.title)}
        </h2>
      )}
      <div className="raw-html-global py-8 body-16-light [&>p]:py-1 [&>p]:body-16-light">
        {parseToHtml(data.description)}
      </div>
      <div className={data.discount_code ? 'w-full sm:w-3/4' : 'w-full'}>
        <Voucher code={data.discount_code} />
        {data.cta && (
          <CTA
            CosmicModule={CosmicModule}
            fullWidth={!!data.discount_code}
            variant={data.cta?.metadata?.variant || 'outlineWhite'}
            data={data.cta.metadata}
            textColor={data?.dark_text ? 'black' : 'white'}
            parentBG={data?.dark_text ? 'light' : 'dark'}
            onCTAClick={() => handleClick()}
          />
        )}
      </div>
      {data?.footer_icon?.url && (
        <>
          <div className="h-16 w-full border-t border-pearl bg-transparent" />
          <div className="mt-auto">
            <Image src={data.footer_icon.url} />
          </div>
        </>
      )}
    </div>
  );
};

export default PromoContent;
